import React from 'react';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';

import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import { getElementId, getTitle } from '../../../../../../../common/elements/utils/elementPropertyUtils';
import { updateTag } from '../../../../../../../common/tags/tagActions';
import Icon from '../../../../../../components/icons/Icon';

import { Button } from '@milanote/roma';
import { ArrowNarrowRight } from '@untitledui/icons';
import { TagEditContentProps } from './TagEditContent';

const TagMoveButtons: React.FC<TagEditContentProps> = ({ tag, tagElements, shareRootPath, closePopup }) => {
    if (!tag || !shareRootPath) return null;

    const dispatch = useDispatch();

    const translate = useTranslator('popup', 'tags.edit');
    const tagRootId = tag.rootBoardIds[0];

    const isUsedOnElementInParentBoard = (rootBoardId: string) => {
        if (isEmpty(tagElements)) return false;

        const tagRootIndex = shareRootPath.findIndex((el) => getElementId(el) === rootBoardId);
        const parentBoardSet =
            tagRootIndex !== -1 ? new Set(shareRootPath.slice(0, tagRootIndex).map(getElementId)) : new Set();

        return tagElements.some((element) => parentBoardSet.has(element.elementParentId));
    };

    const handleMoveTag = (newRootBoardId: string) => {
        if (isUsedOnElementInParentBoard(newRootBoardId)) return;

        dispatch(updateTag(tag.id, { rootBoardIds: [newRootBoardId] }));
        closePopup();
    };

    return (
        <ul className="TagsMoveButtons mt-2">
            {shareRootPath.map((element, index) => {
                const id = getElementId(element);
                const title = getTitle(element);
                const isEnabled = !isUsedOnElementInParentBoard(id);

                return (
                    <li key={id} className={`flex flex-row`} style={{ marginLeft: `${index * 2}rem` }}>
                        <Button
                            className="flex flex-row items-center"
                            iconLeading={id !== tagRootId && ArrowNarrowRight}
                            color={'link-gray'}
                            onClick={() => handleMoveTag(id)}
                            isDisabled={!isEnabled || id === tagRootId}
                        >
                            <div className="flex w-full gap-1">
                                {id === tagRootId && <Icon name="green-tick" />}
                                <span className={`text-left text-sm ml-1 ${id === tagRootId ? 'text-gray-400' : ''}`}>
                                    {id === tagRootId ? translate('in') : translate('moveTo')}
                                    {'\u00A0'}
                                    <span className="font-bold">{title}</span>
                                </span>
                            </div>
                        </Button>
                    </li>
                );
            })}
        </ul>
    );
};

export default TagMoveButtons;
